import { Attachment, EFileExtensions, MinIOFile } from './types';

export const noop = () => null;

export function getFileInfo(file: Attachment): { name: string; size: number; extension: EFileExtensions } {
  const { size, name } = isMinIOFile(file)
    ? getMinIOFileInfo(file)
    : isBase64File(file)
      ? getBase64FileInfo(file)
      : file;

  return { name, size, extension: name.split('.').pop() as EFileExtensions };
}

function getMinIOFileInfo(file: MinIOFile) {
  const { fileName } = file;

  return { name: fileName, size: 0 };
}

function getBase64FileInfo(base64String: string) {
  const [base64Prefix, base64Data] = base64String.split(',') || base64String;
  const bytes = (base64Data.length * 3) / 4;
  /**
   * dataType: image/png;base64
   * extensionWithBase64: png;base64
   */
  const [dataType, extensionWithBase64] = base64Prefix.split('/');

  return { name: `${dataType.split(':')[1]}.${extensionWithBase64.split(';')[0]}`, size: bytes };
}

export function isBase64File(file: Attachment): file is string {
  return typeof file === 'string';
}

export function isMinIOFile(file: Attachment): file is MinIOFile {
  if (typeof file === 'string') return false;
  return 'downloadOptimizedUrl' in file;
}

export function getFileTypeByExtension(extension: EFileExtensions) {
  switch (extension) {
    case EFileExtensions.PNG:
    case EFileExtensions.JPG:
    case EFileExtensions.JPEG:
    case EFileExtensions.GIF:
    case EFileExtensions.SVG:
      return 'image';
    case EFileExtensions.APK:
    case EFileExtensions.DOC:
    case EFileExtensions.DOCX:
    case EFileExtensions.EXE:
    case EFileExtensions.XLS:
    case EFileExtensions.XLSX:
    case EFileExtensions.PPT:
    case EFileExtensions.PPTX:
    case EFileExtensions.TXT:
    case EFileExtensions.CSV:
    case EFileExtensions.ZIP:
      return 'document';
    case EFileExtensions.PDF:
    case EFileExtensions.MP4:
    case EFileExtensions.MP3:
    case EFileExtensions.MOV:
    case EFileExtensions.OGG:
    case EFileExtensions.WEBM:
      return 'video';
  }
}
